import { Box, Button, Card, CardActions, CardContent, Container, Link, Stack, Typography } from "@mui/material";
import { colors } from "@/theme";
import { ReactComponent as LogoImage } from "../../../assets/navbar-DTV-logo.svg";

const APK_URL =
  "https://meredithstorage.blob.core.windows.net/apk/app-release-1.0.0.apk";

const Android: React.FC = () => {
  return (
    <Container
      maxWidth="sm"
      sx={{
        py: { xs: 5, sm: 8 },
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Stack spacing={4} sx={{ width: "100%" }}>
        <Box textAlign="center">
          <Box sx={{ mb: 2 }}>
            <LogoImage style={{ height: 32, width: 150 }} />
          </Box>
          <Typography variant="h4" sx={{ fontWeight: 700 }}>
            Install DTVRetail for Android
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mt: 1.5 }}>
            Download the latest DTVRetail APK and sideload it on your Android device.
          </Typography>
        </Box>

        <Card
          sx={{
            borderRadius: 3,
            boxShadow: "0px 10px 30px rgba(0,0,0,0.12)",
            border: `1px solid ${colors.neutralGrey200}`,
          }}
        >
          <CardContent>
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
              DTVRetail Android APK
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ mt: 1 }}
            >
              Tap the button below on your Android device to download.
            </Typography>
          </CardContent>
          <CardActions
            sx={{
              px: 2.5,
              pb: 2.5,
              pt: 0,
              justifyContent: "center",
            }}
          >
            <Button
              variant="contained"
              size="large"
              href={APK_URL}
              target="_blank"
              rel="noreferrer"
              sx={{
                px: 5,
                py: 1.5,
                borderRadius: 999,
                fontSize: 18,
                fontWeight: 500,
                textTransform: "none",
                boxShadow: "0px 8px 20px rgba(0,0,0,0.18)",
              }}
            >
              Download APK
            </Button>
          </CardActions>
        </Card>

        <Box>
          <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
            How to sideload
          </Typography>
          <Stack spacing={1} component="ol" sx={{ pl: 3, m: 0 }}>
            <Typography component="li" variant="body1">
              On your Android device, open this page and tap <b>Download APK</b>.
            </Typography>
            <Typography component="li" variant="body1">
              When prompted, allow installs from your browser / file manager (Unknown apps).
            </Typography>
            <Typography component="li" variant="body1">
              Open the downloaded file and confirm <b>Install</b>.
            </Typography>
          </Stack>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
            If your device blocks the install, check Android Settings → Security/Privacy → Install unknown apps.
          </Typography>
        </Box>
      </Stack>
    </Container>
  );
};

export default Android;

